const API_URL =
  "https://cocorrina-production.up.railway.app/api/reviews";

function timeAgo(dateString) {
  const date = new Date(dateString);
  const seconds = Math.floor(
    (Date.now() - date.getTime()) / 1000,
  );

  if (seconds < 60) return "just now";

  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) {
    return `${minutes} minute${minutes === 1 ? "" : "s"} ago`;
  }

  const hours = Math.floor(minutes / 60);
  if (hours < 24) {
    return `${hours} hour${hours === 1 ? "" : "s"} ago`;
  }

  const days = Math.floor(hours / 24);
  if (days < 30) {
    return `${days} day${days === 1 ? "" : "s"} ago`;
  }

  const months = Math.floor(days / 30);
  if (months < 12) {
    return `${months} month${months === 1 ? "" : "s"} ago`;
  }

  const years = Math.floor(months / 12);
  return `${years} year${years === 1 ? "" : "s"} ago`;
}

function renderStars(rating) {
  let html = "";

  for (let i = 1; i <= 5; i++) {
    const src =
      i <= rating
        ? window.COCORRINA_STAR_SOLID
        : window.COCORRINA_STAR_OUTLINE;

    html += `
      <img
        src="${src}"
        alt=""
        width="13"
        height="13"
        loading="lazy"
      >
    `;
  }

  return html;
}

function applySettings(settings) {
  if (!settings) return;

  const heading = document.querySelector(
    "[data-coco-heading]",
  );
  const intro = document.querySelector(
    "[data-coco-intro]",
  );
  const button = document.querySelector(
    ".coco-write-review",
  );
  const googleRating = document.querySelector(
    "[data-coco-google-rating]",
  );
  const googleCount = document.querySelector(
    "[data-coco-google-count]",
  );
  const googleLink = document.querySelector(
    "[data-coco-google-link]",
  );

  if (
    heading &&
    settings.heading !== null &&
    settings.heading !== undefined
  ) {
    heading.textContent = settings.heading;
    heading.style.display = settings.heading.trim()
      ? ""
      : "none";
  }

  if (
    intro &&
    settings.intro !== null &&
    settings.intro !== undefined
  ) {
    intro.textContent = settings.intro;
    intro.style.display = settings.intro.trim()
      ? ""
      : "none";
  }

  if (button && settings.buttonLabel) {
    button.textContent = settings.buttonLabel;
  }

  if (googleRating && settings.googleRating) {
    googleRating.textContent = settings.googleRating;
  }

  if (googleCount && settings.googleReviewCount) {
    googleCount.textContent =
      settings.googleReviewCount;
  }

  if (googleLink && settings.googleUrl) {
    googleLink.href = settings.googleUrl;
  }
}

async function loadReviews() {
  const container = document.querySelector(
    "[data-coco-reviews]",
  );

  if (!container) return;

  try {
    const productId =
      window.COCORRINA_PRODUCT_ID || "";
    const shop = encodeURIComponent(
      window.Shopify?.shop || "",
    );

    const response = await fetch(
      `${API_URL}?productId=${productId}&shop=${shop}`,
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(
        data.error || "Unable to load reviews.",
      );
    }

    applySettings(data.settings);

    const reviews = Array.isArray(data.reviews)
      ? data.reviews
      : [];

    if (reviews.length === 0) {
      container.innerHTML =
        "<p>No reviews yet. Be the first to share your story.</p>";
      return;
    }

    container.innerHTML = reviews
      .map(
        (review) => `
          <article class="coco-review">
            <div class="coco-stars">
              ${renderStars(review.rating)}
            </div>

            <h4>${review.title || "Review"}</h4>

            <p>${review.body}</p>

            <div class="coco-review-meta">
              <strong>${review.customerName}</strong>

              ${
                review.verifiedPurchase
                  ? '<span class="verified">Verified Purchase</span>'
                  : ""
              }

              <span>${timeAgo(review.createdAt)}</span>
            </div>
          </article>
        `,
      )
      .join("");
  } catch (error) {
    console.error(error);
    container.innerHTML =
      "<p>Reviews could not load.</p>";
  }
}

function initializeReviews() {
  const button = document.querySelector(
    ".coco-write-review",
  );
  const modal = document.querySelector(
    ".coco-review-modal",
  );
  const close = document.querySelector(
    ".coco-review-modal__close",
  );
  const form = document.querySelector(
    ".coco-review-form",
  );

  if (!button || !modal || !form) return;

  if (button.dataset.cocoInitialized === "true") {
    return;
  }

  button.dataset.cocoInitialized = "true";

  loadReviews();

  const modalHeading = modal.querySelector(
    "[data-coco-modal-heading]",
  );
  const modalIntro = modal.querySelector(
    "[data-coco-modal-intro]",
  );
  const originalForm = form.innerHTML;

  button.addEventListener("click", () => {
    if (modalHeading) {
      modalHeading.style.display = "";
    }

    if (modalIntro) {
      modalIntro.style.display = "";
    }

    if (
      form.querySelector(
        ".coco-review-thank-you",
      )
    ) {
      form.innerHTML = originalForm;
    }

    modal.classList.add("is-open");
  });

  close?.addEventListener("click", () => {
    modal.classList.remove("is-open");
  });

  modal.addEventListener("click", (event) => {
    if (event.target === modal) {
      modal.classList.remove("is-open");
    }
  });

  form.addEventListener(
    "submit",
    async (event) => {
      event.preventDefault();

      const formData = new FormData(form);

      formData.append(
        "productId",
        window.COCORRINA_PRODUCT_ID || "",
      );
      formData.append(
        "productHandle",
        window.COCORRINA_PRODUCT_HANDLE || "",
      );
      formData.append(
        "productTitle",
        window.COCORRINA_PRODUCT_TITLE ||
          "Cocorrina Product",
      );

      const submitButton =
        form.querySelector(
          "button[type='submit']",
        );

      if (!submitButton) return;

      submitButton.textContent =
        "Leaving your words...";
      submitButton.disabled = true;

      try {
        const response = await fetch(API_URL, {
          method: "POST",
          body: formData,
        });

        const result = await response.json();

        if (!response.ok) {
          throw new Error(
            result.error ||
              "Unable to submit review.",
          );
        }

        if (!result.success) {
          throw new Error(
            result.error ||
              "Unable to submit review.",
          );
        }

        if (modalHeading) {
          modalHeading.style.display = "none";
        }

        if (modalIntro) {
          modalIntro.style.display = "none";
        }

        form.innerHTML = `
          <div class="coco-review-thank-you">
            <div class="coco-stars">
              ${renderStars(5)}
            </div>

            <h4>Thank you</h4>

            <p>
              Your words have been received.<br>
              After a short review, they’ll become part of this piece’s story.
            </p>

            <button
              type="button"
              class="coco-review-thank-you-close"
            >
              Close
            </button>
          </div>
        `;

        form
          .querySelector(
            ".coco-review-thank-you-close",
          )
          ?.addEventListener("click", () => {
            modal.classList.remove("is-open");
          });
      } catch (error) {
        console.error(error);
        submitButton.textContent =
          "Leave My Words";
        submitButton.disabled = false;
      }
    },
  );
}

if (document.readyState === "loading") {
  document.addEventListener(
    "DOMContentLoaded",
    initializeReviews,
  );
} else {
  initializeReviews();
}

document.addEventListener(
  "shopify:section:load",
  initializeReviews,
);